type ResidentSortValue = {
  name: string;
  kana?: string | null;
  displayOrder?: number | null;
  display_order?: number | null;
};

const japaneseCollator = new Intl.Collator('ja', {
  usage: 'sort',
  sensitivity: 'base',
  numeric: true
});

export const normalizeResidentKana = (value: string): string =>
  value
    .normalize('NFKC')
    .replace(/[ァ-ヶ]/g, character => String.fromCharCode(character.charCodeAt(0) - 0x60))
    .replace(/[\s　・･]/g, '')
    .toLowerCase();

export const hasResidentKana = (value: ResidentSortValue): boolean =>
  normalizeResidentKana(value.kana ?? '').length > 0;

export const compareResidentsByKana = (left: ResidentSortValue, right: ResidentSortValue): number => {
  const leftKana = normalizeResidentKana(left.kana ?? '');
  const rightKana = normalizeResidentKana(right.kana ?? '');

  if (leftKana && !rightKana) return -1;
  if (!leftKana && rightKana) return 1;

  const readingComparison = japaneseCollator.compare(leftKana || left.name, rightKana || right.name);
  if (readingComparison !== 0) return readingComparison;

  const nameComparison = japaneseCollator.compare(left.name, right.name);
  if (nameComparison !== 0) return nameComparison;

  const leftOrder = left.displayOrder ?? left.display_order ?? Number.MAX_SAFE_INTEGER;
  const rightOrder = right.displayOrder ?? right.display_order ?? Number.MAX_SAFE_INTEGER;
  return leftOrder - rightOrder;
};
